var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMetamask(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 34,
    viewBox: "0 0 139 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122.935 17.0355C122.307 16.607 121.621 16.3214 120.936 15.9501C120.507 15.7216 120.05 15.4932 119.679 15.179C119.051 14.6649 119.165 13.6367 119.851 13.1797C120.793 12.5514 122.364 12.8941 122.535 14.1794C122.535 14.2079 122.564 14.2365 122.592 14.2365H124.02C124.049 14.2365 124.078 14.2079 124.078 14.1794C123.992 13.294 123.649 12.5514 123.021 12.0658C122.421 11.6089 121.736 11.3804 120.993 11.3804C117.223 11.3804 116.88 15.3789 118.908 16.6356C119.137 16.7784 121.136 17.778 121.85 18.235C122.564 18.6634 122.764 19.4631 122.478 20.0915C122.193 20.6627 121.479 21.0625 120.764 21.0054C119.965 20.9483 119.365 20.5199 119.137 19.863C119.108 19.7487 119.079 19.5203 119.079 19.406C119.079 19.3774 119.051 19.3489 119.022 19.3489H117.48C117.451 19.3489 117.423 19.3774 117.423 19.406C117.423 20.5199 117.708 21.1482 118.451 21.7195C119.165 22.2621 119.936 22.4906 120.764 22.4906C122.878 22.4906 123.963 21.291 124.192 20.0629C124.363 18.8634 124.02 17.778 122.935 17.0355Z",
    fill: "#0052FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6174 11.6089H54.9319H54.1893C54.1608 11.6089 54.1322 11.6374 54.1322 11.6374L52.8469 15.8359C52.8184 15.893 52.7613 15.893 52.7327 15.8359L51.4475 11.6374C51.4475 11.6089 51.4189 11.6089 51.3903 11.6089H50.6478H49.9623H49.0483C49.0198 11.6089 48.9912 11.6374 48.9912 11.666V22.3764C48.9912 22.4049 49.0198 22.4335 49.0483 22.4335H50.5906C50.6192 22.4335 50.6478 22.4049 50.6478 22.3764V14.2365C50.6478 14.1794 50.7334 14.1508 50.762 14.2079L52.0472 18.435L52.1329 18.7206C52.1329 18.7491 52.1615 18.7491 52.19 18.7491H53.3896C53.4182 18.7491 53.4467 18.7206 53.4467 18.7206L53.5324 18.435L54.8177 14.2079C54.8462 14.1508 54.9319 14.1508 54.9319 14.2365V22.3764C54.9319 22.4049 54.9605 22.4335 54.989 22.4335H56.5313C56.5599 22.4335 56.5884 22.4049 56.5884 22.3764V11.666C56.5884 11.6374 56.5599 11.6089 56.5313 11.6089H55.6174Z",
    fill: "#0052FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1993 11.6089C99.1708 11.6089 99.1422 11.6374 99.1422 11.6374L97.857 15.8359C97.8284 15.893 97.7713 15.893 97.7427 15.8359L96.4575 11.6374C96.4575 11.6089 96.4289 11.6089 96.4003 11.6089H94.0298C94.0012 11.6089 93.9727 11.6374 93.9727 11.666V22.3764C93.9727 22.4049 94.0012 22.4335 94.0298 22.4335H95.5721C95.6006 22.4335 95.6292 22.4049 95.6292 22.3764V14.2365C95.6292 14.1794 95.7149 14.1508 95.7434 14.2079L97.0287 18.435L97.1144 18.7206C97.1144 18.7491 97.1429 18.7491 97.1715 18.7491H98.3711C98.3996 18.7491 98.4282 18.7206 98.4282 18.7206L98.5139 18.435L99.7991 14.2079C99.8277 14.1508 99.9134 14.1508 99.9134 14.2365V22.3764C99.9134 22.4049 99.9419 22.4335 99.9705 22.4335H101.513C101.541 22.4335 101.57 22.4049 101.57 22.3764V11.666C101.57 11.6374 101.541 11.6089 101.513 11.6089H99.1993Z",
    fill: "#0052FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2088 11.6089H76.3242H74.7819H71.8686C71.8401 11.6089 71.8115 11.6374 71.8115 11.666V13.0084C71.8115 13.0369 71.8401 13.0655 71.8686 13.0655H74.6962V22.3764C74.6962 22.4049 74.7248 22.4335 74.7533 22.4335H76.2956C76.3242 22.4335 76.3527 22.4049 76.3527 22.3764V13.0655H79.1803C79.2088 13.0655 79.2374 13.0369 79.2374 13.0084V11.666C79.266 11.6374 79.2374 11.6089 79.2088 11.6089Z",
    fill: "#0052FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3498 22.4333H89.7493C89.7779 22.4333 89.8064 22.4047 89.8064 22.3476L86.8932 11.6086C86.8932 11.5801 86.8646 11.5801 86.8361 11.5801H86.2934H85.3509H84.8082C84.7797 11.5801 84.7511 11.6086 84.7511 11.6086L81.8379 22.3476C81.8379 22.3761 81.8665 22.4333 81.895 22.4333H83.2945C83.3231 22.4333 83.3516 22.4047 83.3516 22.4047L84.2085 19.263C84.2085 19.2344 84.237 19.2344 84.2656 19.2344H87.3787C87.4073 19.2344 87.4358 19.263 87.4358 19.263L88.2927 22.4047C88.2927 22.4047 88.3212 22.4333 88.3498 22.4333ZM84.6369 17.6921L85.7793 13.4937C85.8079 13.4365 85.865 13.4365 85.8936 13.4937L87.036 17.6921C87.036 17.7207 87.0074 17.7778 86.9789 17.7778H84.7226C84.6654 17.7778 84.6369 17.7207 84.6369 17.6921Z",
    fill: "#0052FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M112.398 22.4333H113.797C113.826 22.4333 113.854 22.4047 113.854 22.3476L110.941 11.6086C110.941 11.5801 110.912 11.5801 110.884 11.5801H110.341H109.399H108.856C108.828 11.5801 108.799 11.6086 108.799 11.6086L105.886 22.3476C105.886 22.3761 105.914 22.4333 105.943 22.4333H107.342C107.371 22.4333 107.399 22.4047 107.399 22.4047L108.256 19.263C108.256 19.2344 108.285 19.2344 108.313 19.2344H111.427C111.455 19.2344 111.484 19.263 111.484 19.263L112.341 22.4047C112.341 22.4047 112.369 22.4333 112.398 22.4333ZM108.685 17.6921L109.827 13.4937C109.856 13.4365 109.913 13.4365 109.941 13.4937L111.084 17.6921C111.084 17.7207 111.055 17.7778 111.027 17.7778H108.77C108.713 17.7778 108.685 17.7207 108.685 17.6921Z",
    fill: "#0052FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8714 20.8341V17.521C62.8714 17.4925 62.8999 17.4639 62.9285 17.4639H67.0699C67.0984 17.4639 67.127 17.4353 67.127 17.4068V16.0644C67.127 16.0358 67.0984 16.0073 67.0699 16.0073H62.9285C62.8999 16.0073 62.8714 15.9787 62.8714 15.9502V13.1226C62.8714 13.0941 62.8999 13.0655 62.9285 13.0655H67.6125C67.6411 13.0655 67.6696 13.0369 67.6696 13.0084V11.666C67.6696 11.6374 67.6411 11.6089 67.6125 11.6089H62.8714H61.272C61.2434 11.6089 61.2148 11.6374 61.2148 11.666V13.0655V16.0358V17.4925V20.9198V22.3764C61.2148 22.4049 61.2434 22.4335 61.272 22.4335H62.8714H67.8124C67.841 22.4335 67.8696 22.4049 67.8696 22.3764V20.9769C67.8696 20.9483 67.841 20.9198 67.8124 20.9198H62.8999C62.8999 20.8912 62.8714 20.8626 62.8714 20.8341Z",
    fill: "#0052FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M137.103 22.319L131.734 16.7782C131.705 16.7496 131.705 16.7211 131.734 16.6925L136.561 11.6658C136.589 11.6372 136.561 11.5801 136.532 11.5801H134.562C134.533 11.5801 134.533 11.5801 134.533 11.6086L130.42 15.8928C130.392 15.9214 130.335 15.8928 130.335 15.8642V11.6943C130.335 11.6658 130.306 11.6372 130.277 11.6372H128.707C128.678 11.6372 128.649 11.6658 128.649 11.6943V22.4047C128.649 22.4333 128.678 22.4618 128.707 22.4618H130.249C130.277 22.4618 130.306 22.4333 130.306 22.4047V17.6921C130.306 17.635 130.363 17.6064 130.392 17.6636L135.019 22.4618L135.047 22.4904H137.018C137.103 22.4333 137.132 22.3476 137.103 22.319Z",
    fill: "#0052FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7721 1L20.3184 11.0083L22.8204 5.10176L33.7721 1Z",
    fill: "#E17726",
    stroke: "#E17726",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M2.68164 1L16.0534 11.0903L13.6744 5.10176L2.68164 1Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9318 24.1748L25.3223 29.6712L33.0336 31.8041L35.2075 24.2979L28.9318 24.1748Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1.28613 24.2979L3.46007 31.8041L11.1304 29.6712L7.56183 24.1748L1.28613 24.2979Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7218 14.905L8.58887 18.1454L16.1771 18.4735L15.931 10.27L10.7218 14.905Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7737 14.905L20.4824 10.188L20.3184 18.4735L27.9066 18.1454L25.7737 14.905Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1318 29.6712L15.7258 27.4562L11.7471 24.3389L11.1318 29.6712Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7676 27.4562L25.3205 29.6712L24.7053 24.3389L20.7676 27.4562Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3235 29.6715L20.7705 27.4565L21.1397 30.4098L21.0987 31.6814L25.3235 29.6715Z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1318 29.6715L15.3977 31.6814L15.3567 30.4098L15.7258 27.4565L11.1318 29.6715Z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4787 22.3702L11.6641 21.2628L14.3302 20.0322L15.4787 22.3702Z",
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0186 22.3702L22.126 20.0322L24.8332 21.2628L21.0186 22.3702Z",
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M11.132 29.6717L11.7883 24.1753L7.56348 24.2983L11.132 29.6717Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M24.709 24.1753L25.3242 29.6717L28.9338 24.2983L24.709 24.1753Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9086 18.1455L20.3203 18.4737L21.0176 22.3703L22.1251 20.0323L24.8323 21.2629L27.9086 18.1455Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6652 21.2629L14.3313 20.0323L15.4798 22.3703L16.1771 18.4737L8.58887 18.1455L11.6652 21.2629Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M8.58887 18.1455L11.7472 24.3392L11.6652 21.2629L8.58887 18.1455Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M24.832 21.2629L24.709 24.3392L27.9084 18.1455L24.832 21.2629Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1768 18.4736L15.4795 22.3703L16.3409 27.0053L16.546 20.8937L16.1768 18.4736Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3194 18.4736L19.9502 20.8937L20.1143 27.0053L21.0167 22.3703L20.3194 18.4736Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0157 22.3702L20.1133 27.0052L20.7696 27.4564L24.7073 24.339L24.8303 21.2627L21.0157 22.3702Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6641 21.2627L11.7461 24.339L15.7248 27.4564L16.3401 27.0052L15.4787 22.3702L11.6641 21.2627Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0991 31.6812L21.1401 30.4097L20.771 30.1226H15.6848L15.3567 30.4097L15.3977 31.6812L11.1318 29.6714L12.6085 30.9019L15.6438 32.9938H20.812L23.8473 30.9019L25.3239 29.6714L21.0991 31.6812Z",
    fill: "#C0AC9D",
    stroke: "#C0AC9D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7688 27.4566L20.1125 27.0054H16.3389L15.7237 27.4566L15.3545 30.4098L15.6826 30.1227H20.7688L21.138 30.4098L20.7688 27.4566Z",
    fill: "#737A99"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3473 11.6646L35.4958 6.1272L33.7731 1L20.7705 10.6802L25.7747 14.905L32.8297 16.9559L34.3884 15.1511L33.7321 14.6589L34.7985 13.6745L33.9782 13.0182L35.0446 12.1978L34.3473 11.6646Z",
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1 6.1272L2.14849 11.6646L1.41018 12.1978L2.47663 13.0182L1.65628 13.6745L2.76376 14.6589L2.06646 15.1511L3.62513 16.9559L10.7212 14.905L15.7253 10.6802L2.68172 1L1 6.1272Z",
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8305 16.9557L25.7754 14.9048L27.9084 18.1452L24.709 24.3388L28.9338 24.2978H35.2095L32.8305 16.9557Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7202 14.9048L3.62414 16.9557L1.28613 24.2978H7.56183L11.7456 24.3388L8.58728 18.1452L10.7202 14.9048Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3197 18.4733L20.7709 10.68L22.8217 5.10156H13.6748L15.7257 10.68L16.1769 18.4733L16.341 20.9344V27.005H20.1146V20.9344L20.3197 18.4733Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.7508277d6e853d7fc4e96ada8c739b9b.svg";
export { ForwardRef as ReactComponent };